import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from './_enums/ENUM__field_graph_interaction';
import { FIELD__base } from './FIELD__base';

export class FIELD__base_visible_connectable extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ABSTRACT;
  /*
   * STATIC METHODS
   */

  static get_meta_params_default() {
    let out = super.get_meta_params_default();
    out.graph__interaction = ENUM__field_graph_interaction.VISIBLE_CONNECTABLE;
    return out;
  }

  /*
   * METHODS
   */
}
